module.exports = __webpack_public_path__ + "static/media/arrowLeftWhite.36f39746.svg";